/* eslint max-params: ["error", 5] */

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../../claim/shared/components/claim-fields/labeled-input';
import LabeledKeyValueDropDown from '../../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledTextArea from '../../../../claim/shared/components/claim-fields/labeled-text-area';
import RgaDomainValues from '../../../shared/rga-domain-values/state/rga-domain-values';
import RgaSearchModel from '../../state/rga-search-model';
import RgaSearchSelectedDomains from '../../state/selected-domains';
import SearchByDropDown from '../../state/search-by-dropdown';
import {findMatchingKey} from '../../../../claim/shared/services/claim-shared-helper';
import moment from 'moment/moment';

function onChangeFormFieldValue(propertyName, props, value) {

    if (value) {

        props.actions.updateRgaSearchObject(propertyName, value);

    } else {

        props.actions.resetRgaSearchObjectValues(propertyName);

    }

}

function onChangeFormFieldListValue(propertyName, props, value) {

    const valueList = value ? value.split(',') : [];

    if (value) {

        props.actions.updateRgaSearchObject(propertyName, valueList);

    } else {

        props.actions.resetRgaSearchObjectListValues(propertyName);

    }

}

/**
 * Handles the change event for a selected domain value in the form.
 * If the domain list is a subdomain list, the domain name and property name should be
 * passed as a dot-separated string. The assumption here is that the domain list and the
 * selected domain value for the domain are kept at the same level in the state.
 *
 * @param {string} propertyName - The name of the property to update.
 * @param {string} domainListName - The name of the domain list to search within.
 * @param searchModelProperty - The name of the property in the search object model to update.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} event - The event object from the change event.
 */

function onChangeSelectedDomainValue(propertyName, domainListName, searchModelProperty, props, event) {

    let selectedDomainValue;

    if (propertyName.split('.').length > 1) {

        const [domainName, subDomainName] = domainListName.split('.');
        const domainList = props.rgaDomainValues[domainName][subDomainName];

        selectedDomainValue = findMatchingKey(event.target.value, domainList);

    } else {

        const domainList = props.rgaDomainValues[domainListName];

        selectedDomainValue = findMatchingKey(event.target.value, domainList);

    }

    props.actions.updateSelectDomainValue(propertyName, selectedDomainValue);
    props.actions.updateRgaSearchObject(searchModelProperty, selectedDomainValue.key);

}

function onClickResetRgaSearchFormBtn() {

    this.actions.resetRgaSearchModelObject();
    this.actions.resetRgaSearchSelectedDomains();
    this.actions.updateSearchQueryString('');
    this.actions.updateSearchByDropDown('RGA_NUMBER');

}

function onClickSearchButton() {

    this.actions.onSearch(this.rgaSearchModel);

}
const RgaSearchForm = props =>
    <section className='rga-filter'>

        <div className='row'>
            <LabeledKeyValueDropDown
                className={'part-request'}
                isEditable={true}
                isValid={true}
                label='Part Request Status'
                list={props.rgaDomainValues.rgaRecallStatus.genericStatus}
                onChange={onChangeSelectedDomainValue.bind(event,
                    'rgaRecallStatus.genericStatus',
                    'rgaRecallStatus.genericStatus',
                    'partRequestStatus',
                    props
                )}
                selectedValue={props.rgaSearchSelectedDomains.rgaRecallStatus.genericStatus}
                tabIndex='1'
            />
            <LabeledKeyValueDropDown
                className={'part-request'}
                isEditable={true}
                isValid={true}
                label='Analysis Status'
                list={props.rgaDomainValues.analysisStatus}
                onBlur={null}
                onChange={onChangeSelectedDomainValue.bind(event,
                    'analysisStatus',
                    'analysisStatus',
                    'analysisStatus',
                    props
                )}
                selectedValue={props.rgaSearchSelectedDomains.analysisStatus}
                tabIndex='2'
            />
            <LabeledKeyValueDropDown
                className={'part-request'}
                isEditable={true}
                isValid={true}
                label='Requestor Type'
                list={props.rgaDomainValues.requesterType}
                onBlur={null}
                onChange={onChangeSelectedDomainValue.bind(event,
                    'requesterType',
                    'requesterType',
                    'requesterType',
                    props
                )}
                selectedValue={props.rgaSearchSelectedDomains.requesterType}
                tabIndex='3'
            />
        </div>
        <div className='row'>
            <LabeledKeyValueDropDown
                className={'part-request'}
                isEditable={true}
                isValid={true}
                label='Request Factory'
                list={props.rgaDomainValues.rgaUnits}
                onBlur={null}
                onChange={onChangeSelectedDomainValue.bind(event,
                    'rgaUnits',
                    'rgaUnits',
                    'factoryCode',
                    props)}
                selectedValue={props.rgaSearchSelectedDomains.rgaUnits}
                tabIndex='4'
            />
            <LabeledInput
                className='part-request'
                isEditable={true}
                label='Log Number(S)'
                maxLength={2000}
                onChange={onChangeFormFieldListValue.bind(event, 'logNumbers', props)}
                tabIndex='5'
                value={props.rgaSearchModel.logNumbers.join(',')}
            />
            <LabeledInput
                className='part-request'
                isEditable={true}
                label='DTAC Case Number'
                maxLength={15}
                onChange={onChangeFormFieldValue.bind(event, 'dtacCaseNumber', props)}
                tabIndex='6'
                value={props.rgaSearchModel.dtacCaseNumber}
            />
        </div>
        <div className='row'>
            <LabeledInput
                className='part-request'
                isEditable={true}
                label='NCCA Car Number'
                maxLength={15}
                onChange={onChangeFormFieldValue.bind(event, 'nccaCarNumber', props)}
                tabIndex='7'
                value={props.rgaSearchModel.nccaCarNumber}
            />
            <LabeledDateInput
                className='part-request'
                date={props.rgaSearchModel.requestFromDate}
                isEditable={true}
                isValid={true}
                label='Request From'
                minDate={0}
                onDateChange={onChangeFormFieldValue.bind(event, 'requestFromDate', props)}
                tabIndex='8'
            />
            <LabeledDateInput
                className='part-request'
                date={props.rgaSearchModel.requestToDate}
                isEditable={true}
                isValid={true}
                label='Request To'
                minDate={props.rgaSearchModel.requestFromDate ? moment.utc(props.rgaSearchModel.requestFromDate).add(1, 'd') : ''}
                onDateChange={onChangeFormFieldValue.bind(event, 'requestToDate', props)}
                tabIndex='9'
            />
        </div>
        <div className='row'>
            {!(props.searchByDropDown.selectedOption.key === 'RGA_NUMBER') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='RGA Number'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'rgaNumbers', props)}
                    tabIndex='10'
                    value={props.rgaSearchModel.rgaNumbers.join(',')}
                />}
            {!(props.searchByDropDown.selectedOption.key === 'WARRANTY_CLAIM') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='Warranty Claim'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'warrantyClaimNumbers', props)}
                    tabIndex='11'
                    value={props.rgaSearchModel.warrantyClaimNumbers.join(',')}
                />}
            {!(props.searchByDropDown.selectedOption.key === 'PART_NUMBER') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='Part Number'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'partNumbers', props)}
                    tabIndex='12'
                    value={props.rgaSearchModel.partNumbers.join(',')}
                />}
        </div>
        <div className='row'>
            {!(props.searchByDropDown.selectedOption.key === 'ANALYST') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='Analyst'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'analystIds', props)}
                    tabIndex='13'
                    value={props.rgaSearchModel.analystIds.join(',')}
                />}
            {!(props.searchByDropDown.selectedOption.key === 'MACHINE_PIN') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='Machine Pin'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'machineSerialNumbers', props)}
                    tabIndex='14'
                    value={props.rgaSearchModel.machineSerialNumbers.join(',')}
                />}
            {!(props.searchByDropDown.selectedOption.key === 'ENGINE_SN') &&
                <LabeledInput
                    className='part-request'
                    isEditable={true}
                    label='Engine SN'
                    maxLength={2000}
                    onChange={onChangeFormFieldListValue.bind(event, 'engineSerialNumbers', props)}
                    tabIndex='15'
                    value={props.rgaSearchModel.engineSerialNumbers.join(',')}
                />}
        </div>
        <div className='row'>
            <LabeledInput
                className='part-request'
                isEditable={true}
                label='Sub System'
                onChange={onChangeFormFieldListValue.bind(event, 'subSystem', props)}
                tabIndex='16'
                value={props.rgaSearchModel.subSystem.join(',')}
            />
        </div>
        <div className='row'>
            <LabeledTextArea
                className='failure-text-area'
                isEditable={true}
                label='Failure Description'
                onChange={onChangeFormFieldValue.bind(event, 'failureDescription', props)}
                tabIndex='17'
                value={props.rgaSearchModel.failureDescription}
            />
        </div>
        <div className='row'>
            <LabeledTextArea
                className='failure-text-area'
                isEditable={true}
                label='Findings'
                onChange={onChangeFormFieldValue.bind(event, 'findings', props)}
                tabIndex='18'
                value={props.rgaSearchModel.findings}
            />
        </div>
        <section className='button-group'>
            <button
                className='secondary'
                onClick={onClickResetRgaSearchFormBtn.bind(props)}
            >
                <FormattedMessage id='Clear Form'/>
            </button>
            <button
                className='primary'
                onClick={onClickSearchButton.bind(props)}
            >
                <FormattedMessage id='SEARCH'/>
            </button>
        </section>
    </section>;

RgaSearchForm.displayName = 'SearchFilter';
RgaSearchForm.propTypes = {
    actions: PropTypes.object.isRequired,
    rgaDomainValues: PropTypes.instanceOf(RgaDomainValues).isRequired,
    rgaSearchModel: PropTypes.instanceOf(RgaSearchModel).isRequired,
    rgaSearchSelectedDomains: PropTypes.instanceOf(RgaSearchSelectedDomains).isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired
};

export default RgaSearchForm;



// WEBPACK FOOTER //
// ./src/rga/search/components/advance-search-rga/rga-search-form.js